module.exports = __webpack_public_path__ + "img/3dMap.ae997cc1.jpg";